/**
 * How long a toast that carries an ACTION must stay on screen.
 *
 * An actionable toast is a control the user can see and not reach: if it times
 * out on the passive default, the action was never really offered. Material 3
 * and Carbon both hold an actionable snackbar open rather than expiring it;
 * Emily's call (board P0, 2026-09-13) is the middle path — a floor, not a
 * fixed value, so a surface with a longer window keeps it.
 *
 * Cross-surface on purpose. Measured 2026-09-13, two surfaces carry an
 * actionable toast and they are built on different toast stacks:
 *
 *   - the extension sidebar: 7 Undo toasts on the in-house `oq-toast`
 *   - the dashboard: one "open the review" toast on Sonner
 *
 * Team Review now uses the same floor for its workflow Undo controls through
 * the review-toast bridge. Without one number here, each stack drifts on its own —
 * which is how the extension's seven ended up written three different ways.
 */
export const ACTIONABLE_TOAST_MIN_MS = 10000;
//# sourceMappingURL=toastHold.js.map